// core
import { Component, Input, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from "rxjs";
import { startWith , distinctUntilChanged } from 'rxjs/operators';

import { RaptorPredicateService } from '../../services/raptor-predicate.service';
import { RaptorControlService } from '../../services/raptor-control.service';
import { RaptorStepService } from '../../services/raptor-step.service';

let section_layout_templates = [
  "default",
  "choose_cover",
  "huddle_black_selector",
  "select_vehicle",
  "home_valuables",
  "knock_out"
]

@Component({
  selector: 'open-raptor-section',
  templateUrl: './raptor-section.component.html',
  styleUrls: ['./raptor-section.component.scss']
})
export class RaptorSectionComponent implements OnInit, OnDestroy {
  @Input() section: any;
  @Input() form!: FormGroup;

  formValueWatcher!: Subscription;
  showSection = true;

  constructor(
    private raptorControlService: RaptorControlService,
    private raptorStepService: RaptorStepService,
    private raptorPredicateService: RaptorPredicateService,
    private container:ElementRef
  ) { }

  ngOnInit(): void {
    this.checkShowIf();

    this.formValueWatcher = this.form.valueChanges
      .pipe(
        startWith(this.form.value),
        distinctUntilChanged((previous, current) => {
          return !this.raptorControlService.formValueChanged(previous, current);
        })
      )
      .subscribe(data => {
        this.checkShowIf();
      });
  }

  ngOnDestroy(): void {
    if (this.formValueWatcher) {
      this.formValueWatcher.unsubscribe();
    }
  }

  checkShowIf(): void {
    if (this.section.show_if && typeof this.section.show_if === 'object') {
      const currentlyVisible = this.showSection;
      this.showSection = this.raptorPredicateService.validator(this.section.show_if, this.form.value);
      
      if ((this.showSection && !currentlyVisible) && this.section?.settings?.scroll_on_show_if) {
        requestAnimationFrame(() => {
          this.container.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      if (!this.showSection && this.section.elements && this.section.elements.length) {
        // check if there are repeater questions and exit edit mode
        this.section.elements.forEach((question: any) => {
          if (question.type === 'repeater') {
            this.raptorStepService.editRepeater(question.key, false);
          }
        });
      }
    }
  }
}
